import { render, staticRenderFns } from "./see.vue?vue&type=template&id=36b0c17d&"
import script from "./see.vue?vue&type=script&lang=js&"
export * from "./see.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports